import React, { useState } from 'react';
import { HeartIcon } from 'lucide-react';
import { Modal } from './Modal';
export function Footer() {
  const [modalContent, setModalContent] = useState<{
    isOpen: boolean;
    title: string;
    content: React.ReactNode;
  }>({
    isOpen: false,
    title: '',
    content: null
  });
  const openModal = (title: string, content: React.ReactNode) => {
    setModalContent({
      isOpen: true,
      title,
      content
    });
  };
  const closeModal = () => {
    setModalContent({
      ...modalContent,
      isOpen: false
    });
  };
  const renderTermsContent = () => <div className="space-y-4 text-gray-700" data-id="element-72">
      <p className="font-medium" data-id="element-73">
        Última actualización: {new Date().toLocaleDateString()}
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-74">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-75">
        Al acceder y utilizar el programa "Reto de Meditación 30 Días", usted
        acepta estar legalmente obligado por estos Términos y Condiciones. Si no
        está de acuerdo con alguno de estos términos, no debe utilizar nuestros
        servicios.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-76">
        2. Descripción del Servicio
      </h4>
      <p data-id="element-77">
        "Reto de Meditación 30 Días" es un programa de desarrollo personal que
        incluye contenido digital, audios de meditación, guías y acceso a
        recursos en línea durante un período de 30 días.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-78">
        3. Registro y Cuenta
      </h4>
      <p data-id="element-79">
        Para acceder al programa completo, debe registrarse y crear una cuenta.
        Usted es responsable de mantener la confidencialidad de su información
        de cuenta y de todas las actividades que ocurran bajo su cuenta.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-80">
        4. Política de Reembolso
      </h4>
      <p data-id="element-81">
        Ofrecemos una garantía de satisfacción de 7 días. Si no está satisfecho
        con el programa, puede solicitar un reembolso completo dentro de los 7
        días posteriores a la compra, sin preguntas.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-82">
        5. Propiedad Intelectual
      </h4>
      <p data-id="element-83">
        Todo el contenido proporcionado en el programa, incluyendo pero no
        limitado a textos, gráficos, logotipos, imágenes, clips de audio, y
        software, está protegido por leyes de propiedad intelectual y pertenece
        a "Reto de Meditación 30 Días" o sus licenciantes.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-84">
        6. Limitación de Responsabilidad
      </h4>
      <p data-id="element-85">
        El programa se proporciona "tal cual" y "según disponibilidad" sin
        garantías de ningún tipo. No garantizamos que el programa satisfaga sus
        requisitos o que sea ininterrumpido, oportuno, seguro o libre de
        errores.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-86">
        7. Modificaciones
      </h4>
      <p data-id="element-87">
        Nos reservamos el derecho de modificar o reemplazar estos términos en
        cualquier momento. Es su responsabilidad revisar estos términos
        periódicamente para verificar cambios.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-88">8. Contacto</h4>
      <p data-id="element-89">
        Si tiene alguna pregunta sobre estos Términos y Condiciones, contáctenos
        a través de la sección de contacto en nuestro sitio web.
      </p>
    </div>;
  const renderPrivacyContent = () => <div className="space-y-4 text-gray-700" data-id="element-90">
      <p className="font-medium" data-id="element-91">
        Última actualización: {new Date().toLocaleDateString()}
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-92">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-93">
        Recopilamos información personal que usted nos proporciona directamente,
        como nombre, dirección de correo electrónico, información de pago y
        cualquier otra información que elija proporcionar.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-94">
        2. Cómo Utilizamos su Información
      </h4>
      <p data-id="element-95">Utilizamos la información recopilada para:</p>
      <ul className="list-disc pl-5 space-y-1" data-id="element-96">
        <li data-id="element-97">Proporcionar, mantener y mejorar nuestros servicios</li>
        <li data-id="element-98">Procesar transacciones y enviar notificaciones relacionadas</li>
        <li data-id="element-99">Enviar comunicaciones, incluyendo promocionales</li>
        <li data-id="element-100">Responder a sus comentarios y preguntas</li>
        <li data-id="element-101">Proteger contra actividades fraudulentas y abusos</li>
      </ul>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-102">
        3. Compartición de Información
      </h4>
      <p data-id="element-103">
        No vendemos, comercializamos ni alquilamos sus datos personales a
        terceros. Podemos compartir información con proveedores de servicios que
        nos ayudan a operar nuestro negocio y entregar servicios.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-104">4. Seguridad</h4>
      <p data-id="element-105">
        Implementamos medidas de seguridad diseñadas para proteger su
        información personal, pero ningún método de transmisión por Internet es
        100% seguro.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-106">
        5. Cookies y Tecnologías Similares
      </h4>
      <p data-id="element-107">
        Utilizamos cookies y tecnologías similares para recopilar información
        sobre sus interacciones con nuestro sitio web y servicios.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-108">6. Sus Derechos</h4>
      <p data-id="element-109">
        Dependiendo de su ubicación, puede tener ciertos derechos con respecto a
        sus datos personales, como el derecho a acceder, corregir o eliminar sus
        datos.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-110">
        7. Cambios a esta Política
      </h4>
      <p data-id="element-111">
        Podemos actualizar esta política de privacidad de vez en cuando. Le
        notificaremos cualquier cambio publicando la nueva política de
        privacidad en esta página.
      </p>
      <h4 className="text-lg font-semibold text-purple-800" data-id="element-112">8. Contacto</h4>
      <p data-id="element-113">
        Si tiene preguntas sobre esta política de privacidad, contáctenos a
        través de la sección de contacto en nuestro sitio web.
      </p>
    </div>;
  const renderContactContent = () => <div className="space-y-6 text-gray-700" data-id="element-114">
      <p data-id="element-115">
        Estamos aquí para ayudarte en tu camino de transformación. No dudes en
        contactarnos para cualquier consulta o asistencia.
      </p>
      <form className="space-y-4" data-id="element-116">
        <div data-id="element-117">
          <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-118">
            Nombre
          </label>
          <input type="text" id="name" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" placeholder="Tu nombre" data-id="element-119" />
        </div>
        <div data-id="element-120">
          <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-121">
            Email
          </label>
          <input type="email" id="email" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" placeholder="tu@email.com" data-id="element-122" />
        </div>
        <div data-id="element-123">
          <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-124">
            Mensaje
          </label>
          <textarea id="message" rows={4} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500" placeholder="¿En qué podemos ayudarte?" data-id="element-125"></textarea>
        </div>
        <button type="submit" className="w-full bg-purple-600 hover:bg-purple-700 text-white font-medium py-2 px-4 rounded-lg transition-colors" data-id="element-126">
          Enviar Mensaje
        </button>
      </form>
      <div className="pt-4 border-t border-gray-200" data-id="element-127">
        <p className="font-medium" data-id="element-128">También puedes contactarnos directamente:</p>
        <p className="mt-2" data-id="element-129">Email: contacto@retomeditacion30dias.com</p>
        <p className="mt-1" data-id="element-130">Teléfono: +54 11 1234 5678</p>
        <p className="mt-1" data-id="element-131">
          Horario de atención: Lunes a Viernes, 9:00 - 18:00 (GMT-3)
        </p>
      </div>
    </div>;
  return <footer className="bg-purple-900 text-white py-12" data-id="element-132">
      <div className="container mx-auto px-4" data-id="element-133">
        <div className="max-w-4xl mx-auto" data-id="element-134">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-135">
            <div className="mb-6 md:mb-0" data-id="element-136">
              <h3 className="text-xl font-bold" data-id="element-137">Reto de Meditación 30 Días</h3>
              <p className="text-purple-300 mt-2" data-id="element-138">Despierta tu paz interior</p>
            </div>
            <div className="flex flex-col md:flex-row gap-4 md:gap-8" data-id="element-139">
              <button onClick={() => openModal('Términos y Condiciones', renderTermsContent())} className="text-purple-200 hover:text-white transition-colors" data-id="element-140">
                Términos y Condiciones
              </button>
              <button onClick={() => openModal('Política de Privacidad', renderPrivacyContent())} className="text-purple-200 hover:text-white transition-colors" data-id="element-141">
                Política de Privacidad
              </button>
              
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-purple-800 text-center" data-id="element-142">
            <p className="flex items-center justify-center text-purple-300" data-id="element-143">
              Creado con <HeartIcon size={16} className="mx-1 text-red-400" data-id="element-144" />{' '}
              para tu transformación interior
            </p>
            <p className="mt-2 text-sm text-purple-400" data-id="element-145">
              © {new Date().getFullYear()} Reto de Meditación 30 Días. Todos
              los derechos reservados.
            </p>
          </div>
        </div>
      </div>
      <Modal isOpen={modalContent.isOpen} onClose={closeModal} title={modalContent.title} data-id="element-146">
        {modalContent.content}
      </Modal>
    </footer>;
}